import { render, staticRenderFns } from "./AppShareModal.vue?vue&type=template&id=b533ecc0&scoped=true"
import script from "./AppShareModal.vue?vue&type=script&lang=js"
export * from "./AppShareModal.vue?vue&type=script&lang=js"
import style0 from "./AppShareModal.vue?vue&type=style&index=0&id=b533ecc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b533ecc0",
  null
  
)

export default component.exports